import { render, staticRenderFns } from "./bookList copy.vue?vue&type=template&id=05472c72&scoped=true"
import script from "./bookList copy.vue?vue&type=script&lang=js"
export * from "./bookList copy.vue?vue&type=script&lang=js"
import style0 from "./bookList copy.vue?vue&type=style&index=0&id=05472c72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05472c72",
  null
  
)

export default component.exports